
export default function UsersDash(){

    return(
        <>
            <h1>Usuarios Dash!!</h1>
        </>
    )

}